import { render, staticRenderFns } from "./DeleteRoleDialog.vue?vue&type=template&id=5b5eff7e&"
import script from "./DeleteRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteRoleDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports